const reasonTypeCodes = {
  DISCOUNT: 1,
  REFUND: 2,
  CANCELLATION: 3,
  PAYMENT: 4,
  RESCHEDULE: 5,
  BLOCKED: 6
};

export {
  reasonTypeCodes
}
